export default {
  name: "",
  description: "",
  percent: null
};
